import { Search, SentimentDissatisfied } from "@mui/icons-material";
import {
  CircularProgress,
  Grid,
  InputAdornment,
  TextField,
} from "@mui/material";
import { Box } from "@mui/system";
import axios from "axios";
import { useSnackbar } from "notistack";
import React, { useEffect, useState } from "react";
import { config } from "../App";
import Cart, { generateCartItemsFrom } from "./Cart";
import Footer from "./Footer";
import Header from "./Header";
import ProductCard from "./ProductCard";
import "./Products.css";


const getDataFronLocalStorage = () =>{
  let user = localStorage.getItem("username");
  // console.log(user)
  if(user){
  // let userName =JSON.parse(localStorage.getItem("username")) ;
  // let name = userName.username;
  // let username = user.split('"')[1];
  // console.log(username,'split')
  return user;
  }else{
    return ""
  }
}

const Products = () => {
const[avatar,setAvater] = useState(getDataFronLocalStorage());
const[productData,setProductData] = useState([]);
const [cartData, setCartData] = useState([]);
const[isLoading,setIsLoading] = useState(false);
const[loggedIn,setIsLoggedIn] = useState(false)
const[searchQuery,setSearchQuery] = useState("");
const[cartItems,setCartItems] = useState([])
const access_token =localStorage.getItem("token");
const { enqueueSnackbar } = useSnackbar();
// Definition of Data Structures used
/**
 * @typedef {Object} Product - Data on product available to buy
 * 
 * @property {string} name - The name or title of the product
 * @property {string} category - The category that the product belongs to
 * @property {number} cost - The price to buy the product
 * @property {number} rating - The aggregate rating of the product (integer out of five)
 * @property {string} image - Contains URL for the product image
 * @property {string} productId - Unique ID for the product
 */

// const Products = () => {

  /**
   * Make API call to get the products list and store it to display the products
   *
   * @returns { Array.<Product> }
   *      Array of objects with complete data on all available products
   *
   * API endpoint - "GET /products"
   *
   * Example for successful response from backend:
   * HTTP 200
   * [
   *      {
   *          "name": "iPhone XR",
   *          "category": "Phones",
   *          "cost": 100,
   *          "rating": 4,
   *          "image": "https://i.imgur.com/lulqWzW.jpg",
   *          "_id": "v4sLtEcMpzabRyfx"
   *      },
   *      {
   *          "name": "Basketball",
   *          "category": "Sports",
   *          "cost": 100,
   *          "rating": 5,
   *          "image": "https://i.imgur.com/lulqWzW.jpg",
   *          "_id": "upLK9JbQ4rMhTwt4"
   *      }
   * ]
   *
   * Example for failed response from backend:
   * HTTP 500
   * {
   *      "success": false,
   *      "message": "Something went wrong. Check the backend console for more details"
   * }
   */
  const performAPICall = async () => {
    try {
      setIsLoading(true)
      let allProducts = await axios.get(config.endpoint+"/products");
      setProductData(allProducts.data)
      setIsLoading(false)
      // console.log(allProducts)
    } catch (error) {
      console.log(error)
      setIsLoading(false)
    }
  };

   
const fetchCart = async() =>{
try {
  let res = await axios.get(`${config.endpoint}/cart`, {
    headers: {
      'Authorization': `Bearer ${access_token}`
    }
  })
  console.log(res,'cdata')
  setCartData(res.data)
} catch (error) {
  console.log(error)
}
}
  // TODO: CRIO_TASK_MODULE_PRODUCTS - Implement search logic
  /**
   * Definition for search handler
   * This is the function that is called on adding new search keys
   *
   * @param {string} text
   *    Text user types in the search bar. To filter the displayed products based on this text.
   *
   * @returns { Array.<Product> }
   *      Array of objects with complete data on filtered set of products
   *
   * API endpoint - "GET /products/search?value=<search-query>"
   *
   */
  const performSearch = async (text) => {
    text = text.toLowerCase();
    try {
      let filteredData = await axios.get(`${config.endpoint}/products/search?value=${text}`)
      setProductData(filteredData.data)
      // console.log(filteredData,'filter')
    } catch (error) {
      console.log(error)
      setProductData([])
    }
   
  };

  // TODO: CRIO_TASK_MODULE_PRODUCTS - Optimise API calls with debounce search implementation
  /**
   * Definition for debounce handler
   * With debounce, this is the function to be called whenever the user types text in the searchbar field
   *
   * @param {{ target: { value: string } }} event
   *    JS event object emitted from the search input field
   *
   * @param {NodeJS.Timeout} debounceTimeout
   *    Timer id set for the previous debounce call
   *
   */
  let timerId;
  const debounceSearch = (event, debounceTimeout) => {
    
    
      const query = event.target.value;
      clearTimeout(timerId);
      timerId = setTimeout(() => {
        performSearch(query);
      }, debounceTimeout); // Set debounce timeout to 500ms
  };


useEffect(() =>{
  performAPICall()
  fetchCart()
},[])

// useEffect(() =>{
//   performSearch(searchQuery)
// },[searchQuery])

// useEffect hook to generate cart items when cart data or products data changes
useEffect(() => {
  const generatedCartItems = generateCartItemsFrom(cartData, productData);
  // console.log('Generated cart items:', generatedCartItems);
  setCartItems(generatedCartItems)
  // You can set the generated cart items to state or use them as needed
}, [cartData, productData]); // This effect will run whenever cartData or productsData changes

const isItemInCart = (data,id) =>{
    let product = data.filter(item => item.productId === id);
    if(product.length>0){
      return true;
    }else{
      return false
    }
}
// Function to add product to cart
const addToCart = async (productId, qty,flag=false) => {
  console.log(productId,qty,'qty',flag)
  // Check if user is logged in (assuming loggedIn state is available)
  if (!access_token) {
    // console.log('Login to add an item to the Cart');
    enqueueSnackbar("Login to add an item to the Cart",{variant: 'warning'})
    return; // Stop further execution
  }

  // Check if item is already in cart
  if (isItemInCart(cartData, productId) && !flag) {
    // console.log('Item already in cart. Use the cart sidebar to update quantity or remove item.');
    enqueueSnackbar("Item already in cart. Use the cart sidebar to update quantity or remove item.",{variant: 'warning'})
    return; // Stop further execution
  }

  try {
    // Make API call to add to cart
    // const response = await axios.post(''productId, qty);
    const response = await axios.post(`${config.endpoint}/cart`, { productId, qty }, {
      headers: {
        'Authorization': `Bearer ${access_token}`
      }
    })
    
    // Update cart data on frontend
    const updatedCartData = [...cartData, { productId, qty }];
    setCartData(response.data);
    
    // console.log('Product added to cart:', response);
  } catch (error) {
    console.error('Error adding product to cart:', error);
  }
};


  return (
    <div>

      <Header children={avatar} search={debounceSearch} hasHiddenAuthButtons={true} >
        
      </Header>


      {/* Search view for mobiles */}
      <TextField
        className="search-mobile"
        size="small"
        fullWidth
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <Search color="primary" />
            </InputAdornment>
          ),
        }}
        placeholder="Search for items/categories"
        name="search"
        onChange={(e) =>debounceSearch(e,500)}
      />
      
      
       <Grid container>
         <Grid item className="product-grid" md={avatar ? 9 : 12} xs={12}>
           <Box className="hero">
             <p className="hero-heading">
               India’s <span className="hero-highlight">FASTEST DELIVERY</span>{" "}
               to your door step
             </p>
           </Box>
          
         {/* </Grid> */}
         {/* </Grid>
         <Grid container> */}
         <Grid container>
         {productData && isLoading ?  (<div className="loading"><CircularProgress color="success" /> Loading Products...</div>) : (
          productData.length>0 ? (productData.map((item,i) =>{
            return(
          <Grid item md={3} xs={6} key={i}>
         <ProductCard product={item} handleAddToCart={addToCart} />
         </Grid>
            )
          })) : (<div className="loading"><SentimentDissatisfied style={{marginBottom:"10px"}}/> No Products found</div>)
          
         ) 
         
         }
         </Grid>
        </Grid>
        {avatar ? (<Grid item style={{backgroundColor:"#E9F5E1"}} md={3} xs={12}>
          <Cart isReadOnly={false} items={cartItems} products={productData} handleQuantity={addToCart}/>
          </Grid>) : ('')}
        
       </Grid>
      <Footer />
    </div>
  );
};

export default Products;
